import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const SearchIcon = ({ fill, height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill={fill}
                d="M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-9 7a9 9 0 1 1 18 0 9 9 0 0 1-18 0z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.943 15.943a1 1 0 0 1 1.414 0l4.35 4.35a1 1 0 0 1-1.414 1.414l-4.35-4.35a1 1 0 0 1 0-1.414z"
                fill={fill}
            />
        </SvgIcon>
    );
};

SearchIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

SearchIcon.defaultProps = {
    fill: MIGRATED_COLORS.black,
    height: '24',
    viewBox: '0 0 24 24',
    width: '24',
};

export default SearchIcon;
